import Highcharts from 'highcharts';
import noDataToDisplayInit from 'highcharts/modules/no-data-to-display';
import HighchartsMore from 'highcharts/highcharts-more';
import DrilldownInit from 'highcharts/modules/drilldown';
import heatmap from 'highcharts/modules/heatmap';
import dumbbell from 'highcharts/modules/dumbbell';
import gantt from 'highcharts/modules/gantt';
import boost from 'highcharts/modules/boost';
import highMaps from 'highcharts/modules/map';
import exportInit from 'highcharts/modules/exporting';
import USAGeoJson from '@highcharts/map-collection/countries/us/us-all.geo.json';
import worldGeoJson from '@highcharts/map-collection/custom/world.geo.json';
import europeGeoJson from '@highcharts/map-collection/custom/europe.geo.json';
import africaGeoJson from '@highcharts/map-collection/custom/africa.geo.json';
import { geoJsonMap } from '/src/features/widgets/components/world-map/world-map-helper';

export const initModule = (mod, highchartsInstance = Highcharts) => {
  if (typeof mod === 'function') {
    mod(highchartsInstance);
  } else if (mod && typeof mod.default === 'function') {
    mod.default(highchartsInstance);
  }
};

initModule(noDataToDisplayInit);
initModule(exportInit);
initModule(HighchartsMore);
initModule(DrilldownInit);
initModule(heatmap);
initModule(gantt);
initModule(boost);
initModule(highMaps);
initModule(dumbbell);

Highcharts.maps[geoJsonMap.USA] = USAGeoJson;
Highcharts.maps[geoJsonMap.World] = worldGeoJson;
Highcharts.maps[geoJsonMap.Africa] = africaGeoJson;
Highcharts.maps[geoJsonMap.Europe] = europeGeoJson;

// Set global options
Highcharts.setOptions({
  palette: {
    colorScheme: 'light'
  },
  lang: {
    numericSymbols: ['k', 'M', 'B', 'T', 'P', 'E']
  }
});

export default defineNuxtPlugin(() => ({
  provide: {
    Highcharts
  }
}));
